import { Inject, Injectable } from '@angular/core';
import { ENV_CONFIG } from '../../tokens/env.token';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  private APP_SETTINGS: any;;
  constructor(
     @Inject(ENV_CONFIG) private ENV: any,
      private keyCloakSrv: KeycloakService
  ) {
    this.APP_SETTINGS = ENV;
   }

 async logoutUser(){
    if(await this.keyCloakSrv.isLoggedIn()) {
      this.keyCloakSrv.logout(this.APP_SETTINGS.KEYCLOAK_URLS.LOGOUT_URL);
    }else {
      this.keyCloakSrv.clearToken();
    }
    localStorage.clear();
    sessionStorage.clear();
  }
}
